<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
  steps: number;
  currentStep: number;
}>();

const getStepStyle = computed(() => (step: number) => {
  let width;
  let backgroundColor = 'var(--ch-blue-100)';

  if (step < props.currentStep) {
    width = '100%';
  } else if (step === props.currentStep) {
    width = '50%';
  } else {
    width = '0%';
    backgroundColor = 'transparent';
  }

  return {
    width,
    backgroundColor,
    transitionDelay: step === props.currentStep ? '0.5s' : '0s'
  };
});
</script>

<template>
  <div class="w-100 d-flex flex-column flex-sm-row align-items-center flex-nowrap" style="gap: 0.5rem">
    <div style="min-width: 4rem; color: var(--ch-blue-100); font-size: var(--font-xs); font-weight: 500;">
      Step {{ currentStep }} of {{ steps }}
    </div>

    <div class="w-100 d-flex align-items-center" style="gap: 0 0.25rem;">
      <div
        v-for="step in steps"
        :key="step"
        class="step-outer w-100"
        style="background-color: var(--ch-sky-blue-50)"
      >
        <div
          class="step-inner"
          :style="getStepStyle(step)"
        ></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.step-outer {
  height: 0.375rem;
  border-radius: 0.5rem;
  overflow: hidden;
}

.step-inner {
  height: 100%;
  border-radius: 0.5rem;
  transition: all 0.5s ease-in-out;
}
</style>
